import type { OperationResult } from '@/contracts/OperationResult';
import type { Tell } from '@/services/Tell';
import type { TelemetryContract } from '@/contracts/TelemetryContract';

export function handleOperationMessages(
  result: OperationResult<any>,
  tell?: Tell,
  telemetry?: TelemetryContract
) {
  result.messages.forEach(({ type, content }) => {
    if (type === 'info') tell?.info(content);
    if (type === 'error') tell?.error(content);
  });

  if (result.hasException && result.exception instanceof Error) {
    telemetry?.trackException(result.exception);
  } else if (result.hasException && result.exception !== undefined) {
    const wrapped = new Error('Unknown exception in operation result');
    telemetry?.trackException(wrapped, telemetry.severityLevel.Warning);
  }

  return result.success;
}